module.exports = __webpack_public_path__ + "img/Physicians-background-green.bb0310f9.svg";